import * as React from 'react';

import cn from 'classnames';

import { Translate } from '@decorators';

import { FormRow, Input } from '@common/components/ui';

import { IDmcaIndividualProps } from './types';

import * as s from './DmcaIndividual.scss';

@Translate('common.containers.Dmca.components.DmcaIndividual')
export class DmcaIndividual extends React.Component<IDmcaIndividualProps> {

	onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const {
			target: {
				value,
				name,
			},
		} = event;
		const { onChange } = this.props;

		onChange({ [name]: value });
	};

	render() {
		const {
			fullName,
			passportSeries,
			passportNumber,
			passportIssueDate,
			passportIssuePlace,
			phone,
			email,
			errorFields,
		} = this.props;

		return (
			<div className={s.block}>
				<FormRow className={s.formRow}>
					<Input
						isValid={!errorFields.includes('fullName')}
						value={fullName}
						name="fullName"
						label={this.t('fullName.label')}
						placeholder={this.t('fullName.placeholder')}
						onChange={this.onChange}
					/>
				</FormRow>

				<FormRow className={cn(s.formRow, s.formRowDense)}>
					<Input
						className={s.passportSeries}
						isValid={!errorFields.includes('passportSeries')}
						value={passportSeries}
						name="passportSeries"
						label={this.t('passportSeries.label')}
						placeholder={this.t('passportSeries.placeholder')}
						onChange={this.onChange}
					/>

					<Input
						className={s.passportNumber}
						isValid={!errorFields.includes('passportNumber')}
						value={passportNumber}
						name="passportNumber"
						label={this.t('passportNumber.label')}
						placeholder={this.t('passportNumber.placeholder')}
						onChange={this.onChange}
					/>
				</FormRow>

				<FormRow className={s.formRow}>
					<Input
						className={s.passportIssueDate}
						isValid={!errorFields.includes('passportIssueDate')}
						value={passportIssueDate}
						name="passportIssueDate"
						label={this.t('passportIssueDate.label')}
						placeholder={this.t('passportIssueDate.placeholder')}
						onChange={this.onChange}
					/>
				</FormRow>

				<FormRow className={s.formRow}>
					<Input
						isValid={!errorFields.includes('passportIssuePlace')}
						value={passportIssuePlace}
						name="passportIssuePlace"
						label={this.t('passportIssuePlace.label')}
						placeholder={this.t('passportIssuePlace.placeholder')}
						onChange={this.onChange}
					/>
				</FormRow>

				<FormRow className={s.formRow}>
					<Input
						className={s.phone}
						isValid={!errorFields.includes('phone')}
						value={phone}
						name="phone"
						label={this.t('phone.label')}
						placeholder={this.t('phone.placeholder')}
						onChange={this.onChange}
					/>
				</FormRow>

				<FormRow className={s.formRow}>
					<Input
						className={s.email}
						isValid={!errorFields.includes('email')}
						value={email}
						name="email"
						label={this.t('email.label')}
						placeholder={this.t('email.placeholder')}
						onChange={this.onChange}
					/>
				</FormRow>
			</div>
		);
	}

}
